import { isProduction } from '../environment';
import { NotificationsAPI as ProdNotificationsAPI } from './notifications-api';
import { MockNotificationsApi } from './mock-notifications-api';

export const NotificationsAPI = isProduction() ? ProdNotificationsAPI : MockNotificationsApi;